import { render, staticRenderFns } from "./InstitutionCard.vue?vue&type=template&id=216b9eda&scoped=true"
import script from "./InstitutionCard.vue?vue&type=script&lang=js"
export * from "./InstitutionCard.vue?vue&type=script&lang=js"
import style0 from "./InstitutionCard.vue?vue&type=style&index=0&id=216b9eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216b9eda",
  null
  
)

export default component.exports